import { createSlice } from "@reduxjs/toolkit";
import { fetchPatientDeliveryRx } from "../../apis/dispense/patientDeliveryRx";
import {
    markPatientPrescriptionsPharmacistSigned,
    patchPatientPrescriptionsPharmacistSignedState,
} from "./pharmacistPrescriptionSignature";

const initialState = {
    loading: false,
    data: null,
    error: null
}

const patientDeliveryRxSlice = createSlice({
    name: 'fetchPatientDeliveryRx',
    initialState,

    extraReducers: (builder) => {
        builder.addCase(fetchPatientDeliveryRx.pending.type, (state) => {
            return {
                ...state,
                loading: true,
                data: null,
                error: null
            }
        })

        builder.addCase(fetchPatientDeliveryRx.fulfilled.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            }
        })

        builder.addCase(fetchPatientDeliveryRx.rejected.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload
            }
        })
        builder.addCase(markPatientPrescriptionsPharmacistSigned, (state, action) => {
            patchPatientPrescriptionsPharmacistSignedState(state, action.payload);
        })
    }

})

export default patientDeliveryRxSlice.reducer
